module.exports = __webpack_public_path__ + "static/media/transIcon.ace3e542.svg";